import { BBBright, GRAY20, H5 } from 'global-styles';
import styled from 'styled-components';
import { MagnifyingGlass } from 'react-loader-spinner';

type Props = {
  loadingText: string;
};

export const GlassLoader = ({ loadingText }: Props) => {
  return (
    <GlassLoaderContainer>
      <MagnifyingGlass
        visible={true}
        height="100"
        width="100"
        ariaLabel="MagnifyingGlass-loading"
        wrapperStyle={{}}
        wrapperClass="MagnifyingGlass-wrapper"
        glassColor="#c0efff"
        color={BBBright}
      />
      <H5>{loadingText}</H5>
    </GlassLoaderContainer>
  );
};
const GlassLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  flex-direction: column;
  color: ${GRAY20};
`;
